import FormattedMessage from 'I18n/components/FormattedMessage';
import { UnifiedHeader } from './UnifiedHeader';
import { jsx as _jsx } from "react/jsx-runtime";
export function SolutionsPartnersPageHeader() {
  return /*#__PURE__*/_jsx(UnifiedHeader, {
    dataTestId: "solutions-partners-page-header",
    pathKey: "SOLUTIONS_PARTNERS",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceStorefront.breadcrumbs.solutions"
    })
  });
}